var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCategory2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_397_1085",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 55,
    height: 55
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 54.6562,
    height: 54.6562,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_397_1085)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.1143 46.6824C9.86172 46.6824 8.78947 46.2376 7.89751 45.348C7.00555 44.4583 6.55957 43.3889 6.55957 42.1397V10.3406C6.55957 9.09133 7.00555 8.02189 7.89751 7.13228C8.78947 6.24266 9.86172 5.79785 11.1143 5.79785H42.9971C44.2496 5.79785 45.3219 6.24266 46.2138 7.13228C47.1058 8.02189 47.5518 9.09133 47.5518 10.3406V42.1397C47.5518 43.3889 47.1058 44.4583 46.2138 45.348C45.3219 46.2376 44.2496 46.6824 42.9971 46.6824H11.1143ZM39.0687 42.1397H42.9971V38.2216L39.0687 42.1397ZM13.05 42.1397H17.2062L24.0382 35.3256H28.8775L22.0455 42.1397H25.6893L32.5213 35.3256H37.3606L30.5286 42.1397H34.2293L41.0613 35.3256H42.9971V10.3406H11.1143V39.2437L15.0427 35.3256H19.882L13.05 42.1397ZM17.1492 30.7828L13.9609 27.6029L24.0382 17.5522L28.5929 22.0949L36.9621 13.7476L40.1504 16.9275L28.5929 28.5115L24.0382 23.9688L17.1492 30.7828Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategory2);
export default __webpack_public_path__ + "static/media/category-2.94a4dfd72b56025a50e575e1e445342f.svg";
export { ForwardRef as ReactComponent };